import { render, staticRenderFns } from "./ScheduleOnboardingModal.vue?vue&type=template&id=5bd9a1b0&scoped=true&"
import script from "./ScheduleOnboardingModal.vue?vue&type=script&lang=ts&"
export * from "./ScheduleOnboardingModal.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleOnboardingModal.vue?vue&type=style&index=0&id=5bd9a1b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9a1b0",
  null
  
)

export default component.exports